import { render } from "./IndicatorLoadMonitoring.vue?vue&type=template&id=06ae1a50&scoped=true&ts=true"
import script from "./IndicatorLoadMonitoring.vue?vue&type=script&lang=ts"
export * from "./IndicatorLoadMonitoring.vue?vue&type=script&lang=ts"

import "./IndicatorLoadMonitoring.vue?vue&type=style&index=0&id=06ae1a50&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06ae1a50"]])

export default __exports__